import { render, staticRenderFns } from "./lookaccount.vue?vue&type=template&id=33a054b9&scoped=true"
import script from "./lookaccount.vue?vue&type=script&lang=js"
export * from "./lookaccount.vue?vue&type=script&lang=js"
import style0 from "./lookaccount.vue?vue&type=style&index=0&id=33a054b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a054b9",
  null
  
)

export default component.exports